"use client";

import React, { useEffect, useRef, useState } from "react";
import Head from "next/head";
import JobsList from "@/features/jobs-list-page/JobsList";
import { LABELS } from "@/common/constants/constants";
import relatedJobs from "@/data/domain/broaden-search.json";
import {
  fetchData,
  fetchGoogleLocation,
  getTitleHelper,
} from "@/common/utils/utils";
import { useRouter } from "next/router";

interface IJobs {
  data: any;
  total: number;
  per_page: number;
  current_page: number;
  currentApi: string;
}

export default function Jobs() {
  let router = useRouter();
  const initialized = useRef(false);
  const [jobs, setJobs] = useState<IJobs>();
  const [customTitle, setCustomTitle] = useState<string>("");
  const [gtmKeyword, setGtmKeyword] = useState<string | string[] | undefined>(
    ""
  );
  const [isUrlModified, setIsUrlModified] = useState(false);
  const [shouldReload, setShouldReload] = useState(false);

  useEffect(() => {
    if (!shouldReload && isUrlModified) {
      const query = getQuery(router.asPath);
      let keyword = decodeURIComponent(query?.keyword);

      const xlocation = query?.xlocation;
      let location: any = "";
      setGtmKeyword(keyword);

      if (keyword === "undefined") keyword = "jobs";
      if (query?.loc_id)
        fetchGoogleLocation(query.loc_id).then((data) => {
          location = data[0][1];
          setTitleAndJobs(keyword, location, "");
        });
      else setTitleAndJobs(keyword, xlocation, "");
    }
    setShouldReload(false);
  }, [router.asPath]);

  useEffect(() => {
    if (!isUrlModified && !initialized.current) {
      initialized.current = true;
      const query = getQuery(router.asPath);
      let keyword = decodeURIComponent(query?.keyword);
      const xlocation = query?.xlocation;
      let adv = query?.adv;
      let location: any = "";
      setGtmKeyword(keyword);
      if (keyword === "undefined") keyword = "jobs";

      if (query?.loc_id)
        fetchGoogleLocation(query.loc_id).then((data) => {
          location = data[0][1];
          setTitleAndJobs(keyword, location, adv);
        });
      else setTitleAndJobs(keyword, xlocation, adv);
      setIsUrlModified(true);
    }
  }, []);

  const getQuery = (pathname: string) => {
    const result: any = {};
    const splited = pathname.split("?")[1];
    if (splited) {
      const query = splited.split("&");
      query.forEach((item) => {
        const key = item.split("=");
        result[`${key[0]}`] = key[1];
      });
    }
    console.log(result, pathname);
    return result;
  };

  const setTitleAndJobs = (keyword: string, location: string, adv: string) => {
    fetchData({
      keyword,
      xlocation: location,
      adv,
    }).then((jobs) => {
      const customTitle = `${jobs?.data?.length || 0} ${
        LABELS.JOBS_TITLE_PART_1
      } ${getTitleHelper({
        keyword,
        gLocation: location,
      })}`;

      setCustomTitle(customTitle);
      setJobs(jobs);

      if (jobs?.currentApi) {
        let currentApi = 0;
        switch (jobs?.currentApi) {
          case "apiWhatJobs":
            currentApi = 1;
            break;
          case "apiXmlJozyJobs":
            currentApi = 2;
            break;
        }
        setShouldReload(true);
        router.push(
          {
            query: {
              ...(keyword ? { keyword } : {}),
              ...(location ? { xlocation: location } : {}),
              adv: adv ? adv : currentApi,
            },
          },
          undefined,
          { shallow: true }
        );
      }
    });
  };

  return (
    <>
      <Head>
        <title>{customTitle}</title>
        <meta name="description" content={customTitle} />
      </Head>

      {jobs && (
        <JobsList
          gtmKeyword={gtmKeyword}
          jobsData={jobs}
          relatedJobs={relatedJobs}
          customTitle={customTitle}
        />
      )}
    </>
  );
}
